const text = (value) => String(value ?? "").trim();
const firstText = (...values) => values.map(text).find(Boolean) || "";
const readSnapshot = (value) => {
  if (!value) return {};
  if (typeof value === "object") return value;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : { Name: text(value) };
  } catch {
    return { Name: text(value) };
  }
};

export const courierBillingOption = (courier) => {
  const name = firstText(courier?.id, courier?.name, courier);
  if (!name) return null;
  return {
    key: `courier:${name}`,
    id: `courier:${name}`,
    name,
    label: name,
    sourceType: "courier",
    sourceKey: name,
    courier: name,
    shippingAccountId: null,
    accountName: null,
    accountNumber: null,
    postalZipCode: null,
  };
};

export const shippingAccountBillingOption = (account) => {
  const shippingAccountId = account?.shippingAccountId ?? account?.id ?? account?.value ?? account?.accountId;
  if (shippingAccountId === null || shippingAccountId === undefined || text(shippingAccountId) === "") return null;
  const accountName = firstText(account?.accountName, account?.AccountName, account?.Name, account?.name) || `Shipping Account ${shippingAccountId}`;
  return {
    key: `shipping-account:${shippingAccountId}`,
    id: `shipping-account:${shippingAccountId}`,
    name: accountName,
    label: accountName,
    sourceType: "shipping-account",
    sourceId: shippingAccountId,
    sourceKey: null,
    courier: firstText(account?.courier, account?.Courier) || null,
    shippingAccountId,
    accountName,
    accountNumber: firstText(account?.accountNumber, account?.AccountNumber) || null,
    postalZipCode: firstText(account?.postalZipCode, account?.PostalZipCode) || null,
  };
};

export const buildShippingBillingOptions = (shippingAccounts = [], couriers = []) => [
  ...couriers.map(courierBillingOption).filter(Boolean),
  ...shippingAccounts.map(shippingAccountBillingOption).filter(Boolean),
];

/** Resolve current or historical billSupplier/billSupplierInfo snapshots without a DB lookup. */
export const resolveShippingBillingIdentity = (value) => {
  const snapshot = readSnapshot(value?.billSupplierInfo ?? value?.billSupplier ?? value);
  const sourceType = text(snapshot?.sourceType).toLowerCase();
  const shippingAccountId = snapshot?.shippingAccountId ?? snapshot?.id ?? null;
  if (sourceType === "shipping-account" || (shippingAccountId !== null && text(shippingAccountId))) {
    return shippingAccountBillingOption({ ...snapshot, shippingAccountId });
  }

  const courier = firstText(
    snapshot?.courier,
    snapshot?.Courier,
    sourceType === "courier" ? snapshot?.sourceKey : ""
  );
  if (courier) return courierBillingOption(courier);

  // Legacy/custom snapshots often stored only Name. Keep them displayable as a
  // courier identity rather than inventing a ShippingAccount row.
  const legacyName = firstText(
    snapshot?.accountName,
    snapshot?.Name,
    snapshot?.name,
    typeof value === "string" ? value : ""
  );
  return legacyName ? courierBillingOption(legacyName) : null;
};
